import apiConfig from "../config";
import { TokenType } from "../../Types/Auth";
import RequestError from "../../Types/RequestError";

interface ServerResponse {
	data: RequestSuccessType;
}

interface RequestSuccessType {
	token: TokenType;
	data: any;
}

interface RequestResponse extends RequestSuccessType {
	isErr: string | undefined;
}

const registrationCheckEmail = (email: string): Promise<RequestResponse> => {
	// возможно битый брошенный запрос...позже понять
	return apiConfig()
		.post<ServerResponse>(`/user/send-verification-code`, {
			email: email,
		})
		.then(
			({ data }) =>
				({
					isErr: undefined,
					data: data,
				} as RequestResponse)
		)
		.catch(
			({ response: { data } }: RequestError) =>
				({
					isErr: data.message,
					data: undefined,
				} as RequestResponse)
		);
};

export default registrationCheckEmail;
